import React from "react";
import { Comment } from "./ReviewCard.style";
import { ProductsRow, ProductsCol, CardWrapper } from "../../styled/pages.style";
import t from '../../i18n/translate';
import API from '../../network/redAPI';
import { useState } from "react";
import { useEffect } from "react";

const ReviewCard = () => {

    const [dataList, setDataList] = useState([]);
    let lang = localStorage.getItem('lang');
    const getAllReviewCard = async () => {
        try{
            await API.getHomePageReviewCard()
            .then(res => res.json())
            .then(res => {
                    if (res.success === true) {
                        setDataList(res.data);
                    }
                });
        }catch(error){
            console.log(error);
        }
    }

    useEffect(() => {
        getAllReviewCard();
    },[])

    return (
        <ProductsRow>
            {dataList.map((data) => 
                <ProductsCol style={{ marginTop: "20px" }} key={data.id}>
                    <CardWrapper>
                        <blockquote><p>{lang === "km" && data.comment_km ? data.comment_km : data.comment}</p></blockquote>
                        <Comment>{lang === "km" && data.name_km ? data.name_km : data.name}</Comment>
                    </CardWrapper>
                </ProductsCol>
                )
            }
            {/* <ProductsCol style={{marginTop: "20px"}}>
                <CardWrapper>
                    <blockquote><p>{ t('home_testimonial_a_great_service') }</p></blockquote>
                    <Comment>{ t('home_testimonial_a_great_service_auth') }</Comment>
                </CardWrapper>
            </ProductsCol> */}
            {/* <ProductsCol style={{marginTop: "20px"}}>
                <CardWrapper>
                <blockquote><p>{ t('home_testimonial_smooth_delivery') }</p></blockquote>
                <Comment>{ t('home_testimonial_smooth_delivery_auth') }</Comment>
                </CardWrapper>
            </ProductsCol>
            <ProductsCol style={{marginTop: "20px"}}>
                <CardWrapper>
                <blockquote><p>{ t('home_testimonial_reusable_tote_bag') }</p></blockquote>
                <Comment>{ t('home_testimonial_reusable_tote_bag_auth') }</Comment>
                </CardWrapper>
            </ProductsCol> */}
        </ProductsRow>
    );
  };  
  export default ReviewCard;
  